import React from 'react';
import styles from './PS.scss';

const PS = ({data}) => {

	if (!data.content) {
		return null;
	}

	return (
	  <div
		className={styles.ps}
		dangerouslySetInnerHTML={{__html: data.content}}>
	  </div>
	);
}

export default PS;
